import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { fetchBadge, badgeDims, SAMPLE_VISIT } from "@/lib/visitorBadge";

// Pixel-exact preview: the server renders the same PDF that gets printed and returns it as a PNG.
export function BadgePreview({ cfg, visit = SAMPLE_VISIT, scale = 1 }) {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const key = JSON.stringify(cfg);
  const { w, h } = badgeDims(cfg);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const blob = await fetchBadge(visit, cfg, "png");
        if (alive) setUrl((old) => { if (old) URL.revokeObjectURL(old); return URL.createObjectURL(blob); });
      } catch { /* keep last preview */ }
      finally { if (alive) setLoading(false); }
    }, 350);
    return () => { alive = false; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, visit]);

  return (
    <div className="relative inline-block rounded-md shadow-lg ring-1 ring-slate-200 overflow-hidden bg-white" style={{ width: `${w * scale}in`, height: `${h * scale}in` }} data-testid="badge-preview">
      {url && <img src={url} alt="Badge preview" className="block h-full w-full" />}
      {loading && <div className="absolute inset-0 flex items-center justify-center bg-white/60"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>}
    </div>
  );
}
